export const getPlaceholder = (params = {}) => {
  const { isOpenSuggestions } = params
  if (isOpenSuggestions) return 'dashboard_search-messages-people-files-more'
  return 'dashboard_search-in-nixi1'
}
